import { ViewEntityDialog } from "components/viewDialog/ViewEntityDialog";
import { IViewEntityField } from "components/viewDialog/ViewEntityDialog.types";
import { AccessType } from "models/IAccessLLMModel";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { IViewAccessLLMModelProps } from "./ViewAccessLLMModel.types";

export const ViewAccessLLMModel = (
  props: IViewAccessLLMModelProps,
): JSX.Element => {
  const users = useSelector((state: RootState) => state.usersSlice.value);
  const { model, isOpen, onDismiss } = props;

  const fields: IViewEntityField[] = [
    { label: "Name", value: model.name },
    { label: "Display Name", value: model.displayName },
    {
      label: "Access Type",
      value:
        model.accessType.charAt(0).toUpperCase() + model.accessType.slice(1),
    },
    { label: "Order", value: model.order },
  ];

  if (
    model.accessType === AccessType.LIMITED &&
    model.allowedUsers.length > 0
  ) {
    const allowedUsersLabel = model.allowedUsers
      .map((userId) => users.find((u) => u.id === userId)?.displayName)
      .filter(Boolean)
      .join(", ");
    fields.push({ label: "Allowed Users", value: allowedUsersLabel });
  }

  return (
    <ViewEntityDialog
      isOpen={isOpen}
      onDismiss={onDismiss}
      title="View AI Model"
      fields={fields}
    />
  );
};
